import * as Sentry from "@sentry/browser";
import { Button } from "primereact/button";
import { Card as CardPrime } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import { Tooltip } from "primereact/tooltip";
import React, { Component } from "react";
import { connect } from "react-redux";

import { salesGraphActions } from "../../actions";
import { getIsCypressAut } from "../../helpers/isCypressAut";
import { isInternalAjwUser } from "../../helpers/isInternalAjwUser";
import { apiService } from "../../services";
import { salesOrderService } from "../../services/salesorder.service";
import ChartsModernized from "../Orders.Sales/Charts/ChartsModernized";
import "./dashboard.scss";

const INTERNAL_AUDIENCE = "internal";
const EXTERNAL_AUDIENCE = "external";

const ACTION_VARIANT_CLASS = {
  orders: "dashboard-action-card--orders",
  exchanges: "dashboard-action-card--exchanges",
  newRequest: "dashboard-action-card--new-request",
};

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderSearchValue: "",
      exchangeSearchValue: "",
      globalSearchValue: "",
      WaitingSearch: false,
      noPartFound: false,
      popoverOpen: false,
      ordersPermiss: undefined,
      exchangesPermiss: undefined,
      exchangesWritePermiss: undefined,
    };

    this.dashBoardContent = this.dashBoardContent.bind(this);
    this.updateState = this.updateState.bind(this);
    this.globalSearch = this.globalSearch.bind(this);
    this.handleKeypress = this.handleKeypress.bind(this);
  }

  globalSearch() {
    if (this.state.globalSearchValue) {
      this.setState({ noPartFound: false });
      this.setState({ WaitingSearch: true });

      //incase any slashes, replace them with URL encoded / and trim any whitespce
      let input = this.state.globalSearchValue
        .replaceAll("/", "%2F")
        .trim();
      apiService.getGlobalSearchData(input).then((res) => {
        this.setState({ WaitingSearch: false });
        if (!res || !res.data || !res.data.length) {
          this.setState({ noPartFound: true });
        } else {
          if (res.data.length > 1 && this.state.ordersPermiss) {
            //go to orders
            window.location.href = `#/orders/sales?CompanyRefNumber=${res.data[0].companyRef}`;
          } else if (
            res.data[0].orderType === "R" &&
            this.state.repairsPermiss
          ) {
            window.location.href = `#/orders/adhoc?customerPO=${res.data[0].companyRef}`;
          } else if (
            res.data[0].orderType === "E" &&
            this.state.exchangesPermiss
          ) {
            //GO TO EXHANGE
            window.location.href = `#/exchanges?CustomerPO=${res.data[0].companyRef}`;
          } else {
            //got to orders
            window.location.href = `#/orders/sales?CompanyRefNumber=${res.data[0].companyRef}`;
          }
          //get kicked out with none of the permissions so the search is disabled
        }
      });
    }
  }

  handleKeypress(e) {
    if (e.charCode === 13) {
      switch (e.target.id) {
        case "globalSearch":
          this.globalSearch();
          break;
        case "saleorder":
          this.goToOrder();
          break;
        case "exchange":
          this.goToExchange(e);
          break;

        default:
          break;
      }
    }
  }

  goToOrder(allOrders) {
    if (allOrders || !this.state.orderSearchValue) {
      window.location.href = "#/orders/sales?all=true";
    } else {
      window.location.href = `#/orders/sales?SoNumber=${this.state.orderSearchValue}`;
    }
  }

  goToExchange(allExchanges) {
    this.props.resetWaitFilter();
    if (allExchanges || !this.state.exchangeSearchValue) {
      window.location.href = "#/exchanges?all=true";
    } else {
      window.location.href = `#/exchanges?CustomerPO=${this.state.exchangeSearchValue}`;
    }
  }

  updateState(e) {
    this.setState({ exchangeSearchValue: e.target.value });
  }

  dashBoardContent(state, props) {
    const that = this;
    return [
      {
        key: 1,
        variant: "orders",
        content() {
          return (
            <div className="dashboard-action-card__icon-wrap">
              {!that.state.ordersPermiss && (
                <Tooltip
                  target=".ordersTarget"
                  mouseTrack
                  mouseTrackLeft={10}
                >
                  Permissions are requred to view orders
                </Tooltip>
              )}
              <i className="fas fa-shopping-bag dashboard-action-card__icon" />
            </div>
          );
        },
        permission: "Order.Read",
        title: "Recent Orders",
        onClick(e) {
          that.state.ordersPermiss && props.setOrders(e);
        },
        className: "ordersTarget pointer dashboard-action-card",
      },
      {
        key: 2,
        variant: "exchanges",
        content() {
          return (
            <div className="dashboard-action-card__icon-wrap">
              {!that.state.exchangesPermiss && (
                <Tooltip
                  target=".exchangeTarget"
                  mouseTrack
                  mouseTrackLeft={10}
                >
                  Permissions are requred to view items awaiting action
                </Tooltip>
              )}
              <i className="fas fa-exchange-alt dashboard-action-card__icon" />
            </div>
          );
        },
        permission: "ExchangeOrderRequest.Read",
        title: "Exchange Items Awaiting Action",
        onClick(e) {
          that.state.exchangesPermiss &&
            props.setExchanges(e, "?action=Action");
        },
        className: "exchangeTarget pointer dashboard-action-card",
      },
      {
        key: 3,
        variant: "newRequest",
        content() {
          return (
            <div className="dashboard-action-card__icon-wrap">
              {!that.state.exchangesWritePermiss && (
                <Tooltip
                  target=".exchangeTarget2"
                  mouseTrack
                  mouseTrackLeft={10}
                >
                  Permissions are requred to raise new request
                </Tooltip>
              )}
              <i className="fas fa-plus dashboard-action-card__icon" />
            </div>
          );
        },
        permission: "ExchangeOrderRequest.Write",
        audience: EXTERNAL_AUDIENCE,
        title: "New Exchange Request",
        onClick(e) {
          that.state.exchangesWritePermiss &&
            props.setExchanges(e, "?newRequest=true");
        },
        className: "exchangeTarget2 pointer dashboard-action-card",
      },
    ];
  }

  componentDidMount() {
    let repairsPermiss = this.props.user.userPermissions.find(
      (obj) => obj.permission.name == "RepairOrderRequest.Read",
    );
    let ordersPermiss = this.props.user.userPermissions.find(
      (obj) => obj.permission.name == "Order.Read",
    );
    let exchangesPermiss = this.props.user.userPermissions.find(
      (obj) => obj.permission.name == "ExchangeOrderRequest.Read",
    );
    let exchangesWritePermiss = this.props.user.userPermissions.find(
      (obj) => obj.permission.name == "ExchangeOrderRequest.Write",
    );
    this.setState({
      repairsPermiss,
      ordersPermiss,
      exchangesPermiss,
      exchangesWritePermiss,
    });

    if (this.shouldShowSalesOverviewCharts(ordersPermiss)) {
      const graphs = this.props.salesgraphs;
      const hasGraphData =
        graphs &&
        typeof graphs.donutOpen === "number" &&
        typeof graphs.donutClosed === "number";
      if (!hasGraphData) {
        this.props.dispatch(salesGraphActions.getGraphsData());
      }
    }
  }

  shouldShowSalesOverviewCharts(ordersPermiss = this.state.ordersPermiss) {
    return Boolean(
      ordersPermiss && !isInternalAjwUser(this.props.user),
    );
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.alert &&
      Object.keys(this.props.alert).length > 0 &&
      prevProps.alert != this.props.alert
    ) {
      this.setError(true, this.props.alert.message, { sticky: true });
    }
  }

  setError(bool, message, options = { sticky: false }) {
    this.setState({ error: bool });
    if (bool === true) {
      this.growl.show({
        severity: "error",
        summary: "Error Message",
        detail: message,
        life: 9000,
        sticky: options.sticky,
      });
    } else if (bool === false && message) {
      this.growl.show({
        severity: "success",
        summary: "Success",
        detail: message,
        life: 5000,
        sticky: options.sticky,
      });
    }
  }
  onClickDashboardSO() {
    window.location.href = "#/orders/sales";
  }

  shouldShowActionCard(item, isCypress) {
    return (
      isCypress ||
      !item.audience ||
      (item.audience === EXTERNAL_AUDIENCE &&
        this.props.user.companyId !== 2) ||
      (item.audience === INTERNAL_AUDIENCE && this.props.user.companyId === 2)
    );
  }

  renderActionCard(item, isCypress) {
    if (!this.shouldShowActionCard(item, isCypress)) {
      return null;
    }

    const variantClass =
      ACTION_VARIANT_CLASS[item.variant] || "";

    return (
      <CardPrime
        className={`${item.className} ${variantClass}`}
        key={item.key}
        onClick={item.onClick}
      >
        <h3 className="dashboard-action-card__title">{item.title}</h3>
        {item.content()}
      </CardPrime>
    );
  }

  render() {
    const isCypress = getIsCypressAut();
    const allCards = this.dashBoardContent(this.state, this.props);
    const visibleActionCardCount = allCards.filter((item) =>
      this.shouldShowActionCard(item, isCypress),
    ).length;
    const companyName =
      this.props.user &&
      this.props.user.company &&
      this.props.user.company.name;

    const showSalesCharts = this.shouldShowSalesOverviewCharts();
    const dashboardPageClassName = [
      "animated",
      "fadeIn",
      "dashboard-page",
      showSalesCharts ? "" : "dashboard-page--no-charts",
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <div
        className="dashboardWrapper"
        style={isCypress ? { minHeight: "50vh" } : undefined}
      >
        <Toast ref={(el) => (this.growl = el)} baseZIndex={9000} />
        <div className={dashboardPageClassName}>
          <header className="dashboard-page__header">
            <i
              className="fas fa-tachometer-alt dashboard-page__header-icon"
              aria-hidden
            />
            <h1 className="dashboard-page__title">
              {companyName ? `${companyName} Dashboard` : "Dashboard"}
            </h1>
          </header>

          {showSalesCharts && (
            <section
              className="dashboard-section dashboard-section--charts"
              data-testid="dashboard-sales-charts-area"
            >
              <div className="charts-container charts-container--dashboard">
                <ChartsModernized salesgraphs={this.props.salesgraphs} />
              </div>
            </section>
          )}

          <section
            className="dashboard-section dashboard-section--search"
            data-testid="dashboard-global-search-area"
          >
            <div className="dashboard-global-search">
              <div className="dashboard-global-search__brand">
                <i
                  className="fas fa-globe-europe dashboard-global-search__globe"
                  aria-hidden
                />
                <span className="dashboard-global-search__label-text">
                  GLOBAL SEARCH
                </span>
                <Button
                  aria-label="Dashboard-Info-Button"
                  className="dashboard-global-search__info-btn p-button-rounded"
                  tooltip="Quickly access the orders, exchanges and
                        repairs you're looking for using the global
                        search tool. Searching the full Customer or
                        AJW Reference will take you to the item on
                        the relevant page."
                  tooltipOptions={{
                    position: "bottom",
                    style: { width: "300px" },
                  }}
                  label="?"
                />
              </div>
              <div className="dashboard-global-search__control">
                <InputText
                  className="dashboard-global-search__input"
                  tooltip={
                    !this.state.repairsPermiss &&
                    !this.state.ordersPermiss &&
                    !this.state.exchangesPermiss &&
                    "You do not currently have permissions to use the search"
                  }
                  aria-label="Dashboard-global-search"
                  id="globalSearch"
                  placeholder="Customer/AJW Reference"
                  value={this.state.globalSearchValue}
                  autoComplete="off"
                  disabled={this.state.WaitingSearch}
                  onKeyPress={this.handleKeypress}
                  onChange={(e) =>
                    this.setState({
                      globalSearchValue: e.target.value,
                    })
                  }
                />
                <Button
                  aria-label="Dashboard-Search-Button"
                  icon="fas fa-search"
                  className="p-button dashboard-global-search__submit"
                  onClick={() => {
                    this.globalSearch();
                  }}
                  disabled={
                    this.state.WaitingSearch ||
                    !this.state.globalSearchValue.trim() ||
                    (!this.state.repairsPermiss &&
                      !this.state.ordersPermiss &&
                      !this.state.exchangesPermiss)
                  }
                />
              </div>
              {(this.state.WaitingSearch || this.state.noPartFound) && (
                <div className="dashboard-global-search__status">
                  {this.state.WaitingSearch && (
                    <ProgressSpinner
                      style={{ width: "20px", height: "20px" }}
                    />
                  )}
                  {this.state.noPartFound && (
                    <p className="dashboard-global-search__no-match">
                      No match found
                    </p>
                  )}
                </div>
              )}
            </div>
          </section>

          <section
            className="dashboard-section dashboard-section--actions"
            data-testid="dashboard-actions-area"
          >
            <div
              className={`dashboard-actions orders dashboard-actions--count-${visibleActionCardCount}`}
              data-visible-action-cards={visibleActionCardCount}
            >
              {allCards.map((item) =>
                this.renderActionCard(item, isCypress),
              )}
            </div>
          </section>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { orders, retrievingSO } = state.salesorder;
  const alert = state.alert;
  const { user } = state.authentication;
  const salesgraphs =
    state.salesgraphs && state.salesgraphs.graphs
      ? state.salesgraphs.graphs
      : undefined;

  return {
    orders,
    retrievingSO,
    user,
    alert,
    salesgraphs,
  };
}

const connectedDashboardPage = connect(mapStateToProps)(Dashboard);
export default connectedDashboardPage;
